import React, { useState } from "react";
import "./releaseNote.css";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { FaChevronCircleDown } from "react-icons/fa";

const ReleaseNotes = () => {
  const [showv12Feature1, setShowv12Feature1] = useState(true);
  const [showv12Feature2, setShowv12Feature2] = useState(false);

  const releaseNoteOne = require("../../assets/images/releaseNoteOne.png");
  const releaseNoteTwo = require("../../assets/images/releaseNoteTwo.png");
  const releaseNoteThree = require("../../assets/images/releaseNoteThree.png");
  const releaseNoteFour = require("../../assets/images/releaseNoteFour.png");
  const releaseNoteFive = require("../../assets/images/releaseNoteFive.png");
  const releaseNotesix = require("../../assets/images/releaseNoteSix.png");
  const releaseNoteSeven = require("../../assets/images/releaseNoteSeven.png");
  const releaseNoteEight = require("../../assets/images/releaseNoteEight.png");
  const releaseNoteNine = require("../../assets/images/releaseNoteNine.png");
  const JobProcess = require("../../assets/images/JobProcess.png");
  const SrSummary = require("../../assets/images/SR-Summary.png");
  const ChangePasswordNotification = require("../../assets/images/ChangePasswordNotification.png");
  const ChangePassword = require("../../assets/images/ChangePassword.png");
  const allowanceBox = require("../../assets/images/myWorkAllowanceBox.png");
  const incentiveBox = require("../../assets/images/Picture.png");

  const allowanceBoxData = require("../../assets/images/myWorkAllowanceBoxData.png");

  const releaseNoteTen = require("../../assets/images/releaseNoteTen.png");

  const toggleButtonOne = () => {
    setShowv12Feature1(!showv12Feature1);
  };

  const toggleButtonTwo = () => {
    setShowv12Feature2(!showv12Feature2);
  };

  return (
    <div className="release-notes mb-2">
      <div className="release-notes-content">
        <p className="title">Release Notes</p>
        {/* <div className="flex-box">
        <img src={releaseNoteImg} />
      </div> */}
        <div className="mt-4 margin-bottom">
          <Accordion defaultActiveKey={["8"]} alwaysOpen>
            <Accordion.Item eventKey="8">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                03-June-2025
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v12
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        The Incentive Entry for Only Casuals Jobs is Restricted
                        for Branch/HO users
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        To address the scenarios where branch managers still
                        make Incentive entries for technicians' part of a Only
                        Casuals job, the Incentive Field is made non-editable
                        for technicians' part of an Only Casual Job as shown
                        below
                      </li>

                      <div>
                        {" "}
                        <img
                          style={{ width: "70%", padding: "24px" }}
                          src={incentiveBox}
                        />
                      </div>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="7">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                28-Feb-2025
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v11
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Allowances Earned for the Month to be displayed in My
                        works of technicians irrespective of Jobs done in the
                        month{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        To address the scenarios where technicians can earn
                        allowances irrespective of whether they perform jobs or
                        not and hence need to view their allowances in My works.
                      </li>
                      <li className="releaseList">
                        The Card will display the allowances and incentives if
                        applicable and are greater than zero (0) .
                      </li>
                      <li className="releaseList">
                        As shown below, this technician has not performed a job
                        and hence his Incentive is 0 and not displayed. He is
                        eligible for these 2 allowances only and is displayed.
                      </li>
                      <div>
                        {" "}
                        <img
                          style={{ width: "70%", padding: "24px" }}
                          src={allowanceBox}
                        />
                      </div>
                      <li className="releaseList">
                        Example of a scenario with job
                      </li>
                      <div>
                        {" "}
                        <img
                          src={allowanceBoxData}
                          className="wage-mapping-img "
                        />
                      </div>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="0">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                09-Jan-2025
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v10
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Scanning of Uploaded File for protection from Malware{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        An antivirus and antimalware solution has been built in
                        to indicate files that are virus infected.
                      </li>
                      <li className="releaseList">
                        Hence after a file is uploaded in the splice app (Signed
                        SR in SR feature), the user may check the Preview page
                        of the SR.
                      </li>
                      <li className="releaseList">
                        A few minutes after the upload, the user can reload the
                        preview page to know the status of the uploaded file.
                      </li>
                      <li className="releaseList">
                        If the Download icon in the Action field is greyed out,
                        it indicated the file is virus infected and hence it
                        cannot be previewed or downloaded, while if the Download
                        icon is in green color, it indicates the file is clean
                        and is safe to be downloaded and previewed.
                      </li>
                      <li className="releaseList">
                        A note explaining this behavior has been added to the
                        preview page as shown below
                      </li>
                    </ul>
                    <span className="feature-one-heading">
                      <strong>
                        A Note: Please reload the preview page a few minutes
                        after you upload a file to check the file's status. A
                        greyed-out preview/download icon indicates that the file
                        is infected and cannot be previewed or downloaded. A
                        green preview/download icon indicates that the file is
                        clean and can be safely previewed or downloaded.{" "}
                      </strong>
                    </span>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                05-Dec-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v9
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>Service Reports </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        More than one Job can appear in one Service Report (SR).
                        One job can appear only in 1 SR.
                      </li>
                      <li className="releaseList">
                        The job description/qty can be changed in the SR
                      </li>
                      <li className="releaseList">
                        We can Generate a PDF of SR
                      </li>
                      <li className="releaseList">
                        Upload signed copy of SR (Image) or Upload signed copy
                        of Work Permit in lieu of SR where SR is not used.
                      </li>
                      <li className="releaseList">
                        Link SR to Invoice numbers from SAP.
                      </li>
                      <li className="releaseList">
                        No concept of month closure here.
                      </li>
                    </ul>
                  </>

                  <>
                    <span className="feature-one-heading">
                      <strong>Process</strong>{" "}
                    </span>
                    <div className="feature-one-heading">
                      <strong>Job</strong>{" "}
                    </div>
                    <ul className="releaseList">
                      <li className="releaseList">
                        SR home page will list all jobs that have not been
                        attached to an SR
                      </li>
                      <li className="releaseList">
                        Jobs will be picked, and a temporary Pick List will be
                        generated. These jobs should not be listed in home page
                        after this
                        <div>
                          {" "}
                          <img src={JobProcess} className="wage-mapping-img " />
                        </div>
                      </li>
                    </ul>
                  </>
                  <>
                    {" "}
                    <span className="feature-one-heading">
                      <strong>Pick List </strong>{" "}
                    </span>{" "}
                    <ul className="releaseList">
                      <li className="releaseList">
                        Click on the pick number, opens a modal and we can
                        add/remove jobs as required.
                      </li>
                      <li className="releaseList">
                        Modify the job details also as required and save and
                        then Generate an SR
                      </li>
                    </ul>
                  </>
                  <>
                    {" "}
                    <span className="feature-one-heading">
                      <strong>Generated </strong>{" "}
                    </span>{" "}
                    <ul className="releaseList">
                      <li className="releaseList">
                        The SR generated moves into the Generated stage. The SR
                        Number is generated.
                      </li>
                      <li className="releaseList">
                        Click on the SR number, opens a modal and an option to
                        upload the signed document (SR/Register/WP)
                      </li>
                      <li className="releaseList">
                        The SR signed date is captured
                      </li>
                    </ul>
                  </>
                  <>
                    {" "}
                    <span className="feature-one-heading">
                      <strong>Signed </strong>{" "}
                    </span>{" "}
                    <ul className="releaseList">
                      <li className="releaseList">
                        The signed SR moves into the Signed stage.
                      </li>
                      <li className="releaseList">
                        Multiple signed SRs can be selected using a check box
                        and picked to map them to an invoice number.
                      </li>
                      <li className="releaseList">
                        The invoice number and invoice date are captured
                      </li>
                    </ul>
                  </>
                  <>
                    {" "}
                    <span className="feature-one-heading">
                      <strong>Invoiced </strong>{" "}
                    </span>{" "}
                    <ul className="releaseList">
                      <li className="releaseList">
                        The invoices are listed in this stage with all the
                        required details
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>SR Summary</strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        The page provides details and count of below listed
                        stages for respective sites <br /> a) WD no SR – Work
                        Done but these jobs are still not part of an SR
                        <br /> b) SR Not signed – SR generated but still not
                        signed <br /> c)Signed SR (Not invoiced) - SR has been
                        signed but not yet invoiced <br /> D)Invoiced SR-
                        Invoiced SRs
                      </li>
                      <li className="releaseList">
                        The HO is given an All option to view details across all
                        the sites
                      </li>
                      <div>
                        {" "}
                        <strong>Note :</strong> The data is from jobs created
                        from April 2024 till current date of fetch{" "}
                      </div>
                      <div>
                        {" "}
                        <img src={SrSummary} className="wage-mapping-img " />
                      </div>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                28-Oct-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v3
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>Change Password Feature for Technicians </strong>{" "}
                    </span>
                    <div className="div-box">
                      Technician to get a notification from 7 days prior to his
                      password expiry date till the expiry date in the existing
                      Notifications tab in splice app.{" "}
                    </div>
                    <div className="div-box">Example</div>
                    <div className="div-box">
                      When a technician logs in into splice app, and if his
                      password is expiring on Oct 10th, from Oct 3rd till Oct
                      10th , he will get the notification "Your password expires
                      on 10-Oct-2024. Please click on the Change password page
                      to change your password"{" "}
                    </div>

                    <div>
                      {" "}
                      <img
                        src={ChangePasswordNotification}
                        className="wage-mapping-img "
                      />
                    </div>
                    <div className="div-box">Change Password Page : </div>
                    <div className="div-box">
                      In the Change password page shown below, technician has to
                      enter his current password, new password and confirm the
                      new password and hit the Change password button to change
                      his password.{" "}
                    </div>
                    <div>
                      {" "}
                      <img src={ChangePassword} className="wage-mapping-img " />
                    </div>
                    <div className="div-box">
                      If user successfully resets his password, the message{" "}
                      <strong>
                        {" "}
                        Your Password has been reset successfully. Please login
                        using the new password.
                      </strong>
                      will be shown and user will be logged out to enable him to
                      login using new credentials{" "}
                    </div>
                    <div className="div-box">
                      If not successfully reset, the message "{" "}
                      <strong>
                        Your password reset was not successful. Please try again{" "}
                      </strong>{" "}
                      " would be displayed
                    </div>
                    <div className="div-box">
                      The rules for the password are{" "}
                    </div>
                    <ul className="releaseList">
                      <li className="releaseList">
                        It has to be 6 digits in length.{" "}
                      </li>
                      <li className="releaseList">
                        Only numbers are allowed.{" "}
                      </li>
                      <li className="releaseList">
                        Consecutively repeated numbers are not allowed like
                        1111.2222 etc.{" "}
                      </li>
                      <li className="releaseList">
                        Same current password cannot be repeated.{" "}
                      </li>
                    </ul>
                  </>
                </div>
                <div className="div-box">
                  Forceful Re-direction to Change password Page{" "}
                </div>
                <div className="div-box">
                  Two days prior to expiry date (in our example : Oct 8th ),
                  user upon login will be forcefully directed to the Change
                  password page. User will be refrained from performing any
                  other actions (create job etc.) until he changes his password.{" "}
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Five new job types listed below have been added to the
                        splice app{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        OLD BELT Rolling per meter
                      </li>
                      <li className="releaseList">Filter belt splice</li>
                      <li className="releaseList">
                        Belt width above 4 mtr cold process
                      </li>
                      <li className="releaseList">Fold removal</li>
                      <li className="releaseList">Edge trimming</li>
                    </ul>
                    <div className="div-box">
                      The incentives for all these jobs are manually calculated
                      (Incentive Entry) similar to Cold Patch, Hot patch and
                      Others{" "}
                    </div>
                    <div className="div-box">
                      The measures and materials will be same as the existing
                      job types mentioned against each
                    </div>
                    <ul className="releaseList">
                      <li className="releaseList">
                        OLD BELT Rolling per meter-
                        <strong>Belt replacement </strong>
                      </li>
                      <li className="releaseList">
                        {" "}
                        Filter belt splice- <strong>Hot Joint </strong>
                      </li>
                      <li className="releaseList">
                        Belt width above 4 mtr cold process-
                        <strong>Cold vulcanizing </strong>
                      </li>
                      <li className="releaseList">
                        {" "}
                        fold removal-<strong>Belt replacement </strong>
                      </li>
                      <li className="releaseList">
                        {" "}
                        edge trimming-<strong>Belt replacement </strong>
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="3">
              {" "}
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                22-Jul-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v2
              </Accordion.Header>
              <Accordion.Body>
                {/* <div className="modal-heading">
                  The below listed features are made available as part of this
                  release{" "}
                </div> */}
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Technicians not present in the selected site during the
                        job will be highlighted in red{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        As shown below the Technicians highlighted in red are
                        not present on the site during the job and hence need to
                        be removed from the job.
                        <div className="flex justify-between">
                          <img
                            src={releaseNoteOne}
                            className="wage-mapping-img w-45"
                          />
                          <img
                            src={releaseNoteTwo}
                            className="wage-mapping-img w-45"
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        On the click of any action button (Save, Hold, Reject or
                        validate), the below error message would be displayed.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteThree}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Terminated technicians will not be listed in the Field
                        app list of technicians and in the list of technicians
                        listed in the Allowances page
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        Only Active technicians will be listed out in the list
                        of technicians provided in the app.
                      </li>
                      <li className="releaseList">
                        In case a technician is terminated mid-month, he will
                        not be listed in any list after the exit date , while
                        jobs he worked at the beginning of the month will still
                        have his name and he is eligible for those incentives.
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  {/* <button className="button-arounder" onClick={toggleButtonOne}>
                    Feature #1 <FaChevronCircleDown />
                  </button> */}
                  <h3 className="feature-heading"> Feature #3</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>Incentive % split up should be 100 %</strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        An error message indicating that the incentive % split
                        should add up to 100% as shown is displayed on the click
                        of any action button.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteFour}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        In case a technician is terminated mid-month, he will
                        not be listed in any list after the exit date , while
                        jobs he worked at the beginning of the month will still
                        have his name and he is eligible for those incentives.
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #4</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        + sign to check logs of every job is displayed only
                        after a change or an action has been made to the job, by
                        the branch and HO{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        <div>
                          {" "}
                          <img
                            src={releaseNoteFive}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        As shown above, Job # 21098 does not have a + sign to
                        the left, indicating that no changes/action have been
                        made to that job yet.
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #5</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        A loader has been added on the click of the Action
                        button in Allowances{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        <div>
                          {" "}
                          <img
                            src={releaseNotesix}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        To address the duplicate entries of technicians getting
                        added in slow networks, a loader has been added to
                        indicate completion of action to user.
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="4">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                05-Mar-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v10
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <span className="feature-one-heading">
                      <strong>
                        Allowance details and the Total incentive amount for the
                        Month are displayed in the My works page as shown below.{" "}
                      </strong>{" "}
                    </span>
                    <ul className="releaseList">
                      <li className="releaseList">
                        These values will appear only after the HO month
                        closure.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteSeven}
                            className="wage-mapping-img-height "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="5">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                08-Feb-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v9
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        In the My Works tab , as shown below, the Count
                        Displayed on the tile below Pulley lagging is the count
                        of jobs done by the technician and it will not include
                        the rejected jobs.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteEight}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                      <li className="releaseList">
                        On the click of the Tile, you can see all the jobs with
                        its details, and this will include the rejected jobs
                        details also
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        As Shown below ,the expanded view of every job will also
                        highlight the current status of the job with the defined
                        icons given below .
                        <div>
                          {" "}
                          <img
                            src={releaseNoteNine}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #3</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        (% of incentive, Amount of incentive ) -listed for every
                        job in its expanded view will appear only after the HO
                        has authorized the job .
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #4</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        The sum total of all the incentives provided for all the
                        jobs for that particular type of job will be displayed
                        on the tile of that job type under the My Works section
                        .
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="6">
              <Accordion.Header className="font-bold">
                {" "}
                <span className="highlight font-bold">
                  Release Date :{" "}
                </span>{" "}
                02-Aug-2024
                <span className="highlight font-bold margin-left">
                  {" "}
                  Version :{" "}
                </span>{" "}
                v8
              </Accordion.Header>
              <Accordion.Body>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #1</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        Once a technician logs in, a loader will be shown below
                        to indicate that the page is loading and once done the
                        page will be ready for use.
                        <div>
                          {" "}
                          <img
                            src={releaseNoteTen}
                            className="wage-mapping-img "
                          />
                        </div>
                      </li>
                    </ul>
                  </>
                </div>
                <div className="buttons-container">
                  <h3 className="feature-heading"> Feature #2</h3>

                  <>
                    <ul className="releaseList">
                      <li className="releaseList">
                        If there are any unread notifications for that user, it
                        would take him to the Notification tab , if not New Job
                        tab will be his landing page as usual .
                      </li>
                    </ul>
                  </>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>{" "}
    </div>
  );
};

export default ReleaseNotes;
